import { _ as _objectWithoutPropertiesLoose$2, M as Markdown$1, a as _objectSpread2$1, b as _extends } from '../styles.js';
import 'bumbag/styled';
import { createHook as createHook$1, useClassName, createComponent as createComponent$1, createElement as createElement$1 } from 'bumbag/utils';
import { createContext, useContext, createElement, forwardRef as forwardRef$1, memo as memo$1, useDebugValue, useCallback, Fragment } from 'react';
import MarkdownRenderer from 'markdown-react-js';
import { Box as Box$1 } from 'bumbag/Box';
import { Blockquote } from 'bumbag/Blockquote';
import { Divider } from 'bumbag/Divider';
import { Image } from 'bumbag/Image';
import { Link } from 'bumbag/Link';
import { List } from 'bumbag/List';
import { Paragraph } from 'bumbag/Paragraph';
import { Table } from 'bumbag/Table';
import { Text } from 'bumbag/Text';
import { Heading } from 'bumbag/Heading';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SystemContext = /*#__PURE__*/createContext({});

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

function isRenderProp(children) {
  return typeof children === "function";
}

/**
 * Custom hook that will call `children` if it's a function. If
 * `useCreateElement` has been passed to the context, it'll be used instead.
 *
 * @example
 * import React from "react";
 * import { SystemProvider, useCreateElement } from "reakit-system";
 *
 * const system = {
 *   useCreateElement(type, props, children = props.children) {
 *     // very similar to what `useCreateElement` does already
 *     if (typeof children === "function") {
 *       const { children: _, ...rest } = props;
 *       return children(rest);
 *     }
 *     return React.createElement(type, props, children);
 *   },
 * };
 *
 * function Component(props) {
 *   return useCreateElement("div", props);
 * }
 *
 * function App() {
 *   return (
 *     <SystemProvider unstable_system={system}>
 *       <Component url="url">{({ url }) => <a href={url}>link</a>}</Component>
 *     </SystemProvider>
 *   );
 * }
 */

var useCreateElement = function useCreateElement(type, props, children) {
  if (children === void 0) {
    children = props.children;
  }

  var context = useContext(SystemContext);

  if (context.useCreateElement) {
    return context.useCreateElement(type, props, children);
  }

  if (typeof type === "string" && isRenderProp(children)) {
    var _ = props.children,
        rest = _objectWithoutPropertiesLoose$1(props, ["children"]);

    return children(rest);
  }

  return /*#__PURE__*/createElement(type, props, children);
};

/**
 * Splits an object (`props`) into a tuple where the first item is an object
 * with the passed `keys`, and the second item is an object with these keys
 * omitted.
 *
 * @example
 * import { splitProps } from "reakit-utils";
 *
 * splitProps({ a: "a", b: "b" }, ["a"]); // [{ a: "a" }, { b: "b" }]
 */
function splitProps(props, keys) {
  var propsKeys = Object.keys(props);
  var picked = {};
  var omitted = {};

  for (var _i = 0, _propsKeys = propsKeys; _i < _propsKeys.length; _i++) {
    var key = _propsKeys[_i];

    if (keys.indexOf(key) >= 0) {
      picked[key] = props[key];
    } else {
      omitted[key] = props[key];
    }
  }

  return [picked, omitted];
}

/**
 * Compares two objects.
 *
 * @example
 * import { shallowEqual } from "reakit-utils";
 *
 * shallowEqual({ a: "a" }, {}); // false
 * shallowEqual({ a: "a" }, { b: "b" }); // false
 * shallowEqual({ a: "a" }, { a: "a" }); // true
 * shallowEqual({ a: "a" }, { a: "a", b: "b" }); // false
 */
function shallowEqual(objA, objB) {
  if (objA === objB) return true;
  if (!objA) return false;
  if (!objB) return false;
  if (typeof objA !== "object") return false;
  if (typeof objB !== "object") return false;
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);
  var length = aKeys.length;
  if (bKeys.length !== length) return false;

  for (var _i = 0, _aKeys = aKeys; _i < _aKeys.length; _i++) {
    var key = _aKeys[_i];

    if (objA[key] !== objB[key]) {
      return false;
    }
  }

  return true;
}

function forwardRef(component) {
  return /*#__PURE__*/forwardRef$1(component);
}

function memo(component, propsAreEqual) {
  return /*#__PURE__*/memo$1(component, propsAreEqual);
}

/**
 * Creates a React component.
 *
 * @example
 * import { createComponent } from "reakit-system";
 *
 * const A = createComponent({ as: "a" });
 *
 * @param options
 */
function createComponent(_ref) {
  var type = _ref.as,
      useHook = _ref.useHook,
      shouldMemo = _ref.memo,
      _ref$propsAreEqual = _ref.propsAreEqual,
      propsAreEqual = _ref$propsAreEqual === void 0 ? useHook === null || useHook === void 0 ? void 0 : useHook.unstable_propsAreEqual : _ref$propsAreEqual,
      _ref$keys = _ref.keys,
      keys = _ref$keys === void 0 ? (useHook === null || useHook === void 0 ? void 0 : useHook.__keys) || [] : _ref$keys,
      _ref$useCreateElement = _ref.useCreateElement,
      useCreateElement$1 = _ref$useCreateElement === void 0 ? useCreateElement : _ref$useCreateElement;

  var Comp = function Comp(_ref2, ref) {
    var _ref2$as = _ref2.as,
        as = _ref2$as === void 0 ? type : _ref2$as,
        props = _objectWithoutPropertiesLoose$1(_ref2, ["as"]);

    if (useHook) {
      var _as$render;

      var _splitProps = splitProps(props, keys),
          _options = _splitProps[0],
          htmlProps = _splitProps[1];

      var _useHook = useHook(_options, _objectSpread2({
        ref: ref
      }, htmlProps)),
          wrapElement = _useHook.wrapElement,
          elementProps = _objectWithoutPropertiesLoose$1(_useHook, ["wrapElement"]); // @ts-ignore


      var asKeys = ((_as$render = as.render) === null || _as$render === void 0 ? void 0 : _as$render.__keys) || as.__keys;
      var asOptions = asKeys && splitProps(props, asKeys)[0];
      var allProps = asOptions ? _objectSpread2(_objectSpread2({}, elementProps), asOptions) : elementProps;

      var _element = useCreateElement$1(as, allProps);

      if (wrapElement) {
        return wrapElement(_element);
      }

      return _element;
    }

    return useCreateElement$1(as, _objectSpread2({
      ref: ref
    }, props));
  };

  if (process.env.NODE_ENV !== "production" && useHook) {
    Comp.displayName = useHook.name.replace(/^(unstable_)?use/, "");
  }

  Comp = forwardRef(Comp);

  if (shouldMemo) {
    Comp = memo(Comp, propsAreEqual);
  }

  Comp.__keys = keys;
  Comp.unstable_propsAreEqual = propsAreEqual || shallowEqual;
  return Comp;
}

/**
 * React custom hook that returns the value of any token defined in the
 * SystemContext. It's mainly used internally in [`useOptions`](#useoptions)
 * and [`useProps`](#useprops).
 *
 * @example
 * import { SystemProvider, useToken } from "reakit-system";
 *
 * const system = {
 *   token: "value",
 * };
 *
 * function Component(props) {
 *   const token = useToken("token", "default value");
 *   return <div {...props}>{token}</div>;
 * }
 *
 * function App() {
 *   return (
 *     <SystemProvider unstable_system={system}>
 *       <Component />
 *     </SystemProvider>
 *   );
 * }
 */

function useToken(token, defaultValue) {
  useDebugValue(token);
  var context = useContext(SystemContext);
  return context[token] != null ? context[token] : defaultValue;
}

/**
 * React custom hook that returns the props returned by a given
 * `use${name}Props` in the SystemContext.
 *
 * @example
 * import { SystemProvider, useProps } from "reakit-system";
 *
 * const system = {
 *   useAProps(options, htmlProps) {
 *     return {
 *       ...htmlProps,
 *       href: options.url,
 *     };
 *   },
 * };
 *
 * function A({ url, ...htmlProps }) {
 *   const props = useProps("A", { url }, htmlProps);
 *   return <a {...props} />;
 * }
 *
 * function App() {
 *   return (
 *     <SystemProvider unstable_system={system}>
 *       <A url="url">It will convert url into href in useAProps</A>
 *     </SystemProvider>
 *   );
 * }
 */

function useProps(name, options, htmlProps) {
  if (options === void 0) {
    options = {};
  }

  if (htmlProps === void 0) {
    htmlProps = {};
  }

  var hookName = "use" + name + "Props";
  useDebugValue(hookName);
  var useHook = useToken(hookName);

  if (useHook) {
    return useHook(options, htmlProps);
  }

  return htmlProps;
}

/**
 * React custom hook that returns the options returned by a given
 * `use${name}Options` in the SystemContext.
 *
 * @example
 * import React from "react";
 * import { SystemProvider, useOptions } from "reakit-system";
 *
 * const system = {
 *   useAOptions(options, htmlProps) {
 *     return {
 *       ...options,
 *       url: htmlProps.href,
 *     };
 *   },
 * };
 *
 * function A({ url, ...htmlProps }) {
 *   const options = useOptions("A", { url }, htmlProps);
 *   return <a href={options.url} {...htmlProps} />;
 * }
 *
 * function App() {
 *   return (
 *     <SystemProvider unstable_system={system}>
 *       <A href="url">
 *         It will convert href into url in useAOptions and then url into href in A
 *       </A>
 *     </SystemProvider>
 *   );
 * }
 */

function useOptions(name, options, htmlProps) {
  if (options === void 0) {
    options = {};
  }

  if (htmlProps === void 0) {
    htmlProps = {};
  }

  var hookName = "use" + name + "Options";
  useDebugValue(hookName);
  var useHook = useToken(hookName);

  if (useHook) {
    return _objectSpread2(_objectSpread2({}, options), useHook(options, htmlProps));
  }

  return options;
}

/**
 * Transforms `arg` into an array if it's not already.
 *
 * @example
 * import { toArray } from "reakit-utils";
 *
 * toArray("a"); // ["a"]
 * toArray(["a"]); // ["a"]
 */
function toArray(arg) {
  if (Array.isArray(arg)) {
    return arg;
  }

  return typeof arg !== "undefined" ? [arg] : [];
}

/**
 * Creates a React custom hook that will return component props.
 *
 * @example
 * import { createHook } from "reakit-system";
 *
 * const useA = createHook({
 *   name: "A",
 *   keys: ["url"], // custom props/options keys
 *   useProps(options, htmlProps) {
 *     return {
 *       ...htmlProps,
 *       href: options.url,
 *     };
 *   },
 * });
 *
 * function A({ url, ...htmlProps }) {
 *   const props = useA({ url }, htmlProps);
 *   return <a {...props} />;
 * }
 *
 * @param options
 */
function createHook(options) {
  var _options$useState, _composedHooks$;

  var composedHooks = toArray(options.compose);

  var __useOptions = function __useOptions(hookOptions, htmlProps) {
    // Call the current hook's useOptions first
    if (options.useOptions) {
      hookOptions = options.useOptions(hookOptions, htmlProps);
    } // If there's name, call useOptions from the system context


    if (options.name) {
      hookOptions = useOptions(options.name, hookOptions, htmlProps);
    } // Run composed hooks useOptions


    if (options.compose) {
      for (var _iterator = _createForOfIteratorHelperLoose(composedHooks), _step; !(_step = _iterator()).done;) {
        var hook = _step.value;
        hookOptions = hook.__useOptions(hookOptions, htmlProps);
      }
    }

    return hookOptions;
  };

  var useHook = function useHook(hookOptions, htmlProps, unstable_ignoreUseOptions) {
    if (hookOptions === void 0) {
      hookOptions = {};
    }

    if (htmlProps === void 0) {
      htmlProps = {};
    }

    if (unstable_ignoreUseOptions === void 0) {
      unstable_ignoreUseOptions = false;
    }

    // This won't execute when useHook was called from within another useHook
    if (!unstable_ignoreUseOptions) {
      hookOptions = __useOptions(hookOptions, htmlProps);
    } // Call the current hook's useProps


    if (options.useProps) {
      htmlProps = options.useProps(hookOptions, htmlProps);
    } // If there's name, call useProps from the system context


    if (options.name) {
      htmlProps = useProps(options.name, hookOptions, htmlProps);
    }

    if (options.compose) {
      if (options.useComposeOptions) {
        hookOptions = options.useComposeOptions(hookOptions, htmlProps);
      }

      if (options.useComposeProps) {
        htmlProps = options.useComposeProps(hookOptions, htmlProps);
      } else {
        for (var _iterator2 = _createForOfIteratorHelperLoose(composedHooks), _step2; !(_step2 = _iterator2()).done;) {
          var hook = _step2.value;
          htmlProps = hook(hookOptions, htmlProps, true);
        }
      }
    } // Remove undefined values from htmlProps


    var finalHTMLProps = {};
    var definedHTMLProps = htmlProps || {};

    for (var prop in definedHTMLProps) {
      if (definedHTMLProps[prop] !== undefined) {
        finalHTMLProps[prop] = definedHTMLProps[prop];
      }
    }

    return finalHTMLProps;
  };

  useHook.__useOptions = __useOptions;
  var composedKeys = composedHooks.reduce(function (keys, hook) {
    keys.push.apply(keys, hook.__keys || []);
    return keys;
  }, []); // It's used by createComponent to split option props (keys) and html props

  useHook.__keys = [].concat(composedKeys, ((_options$useState = options.useState) === null || _options$useState === void 0 ? void 0 : _options$useState.__keys) || [], options.keys || []);
  useHook.unstable_propsAreEqual = options.propsAreEqual || ((_composedHooks$ = composedHooks[0]) === null || _composedHooks$ === void 0 ? void 0 : _composedHooks$.unstable_propsAreEqual) || shallowEqual;

  if (process.env.NODE_ENV !== "production" && options.name) {
    Object.defineProperty(useHook, "name", {
      value: "use" + options.name
    });
  }

  return useHook;
}

// Automatically generated
var BOX_KEYS = ["unstable_system"];

var useBox = createHook({
  name: "Box",
  keys: BOX_KEYS,
  propsAreEqual: function propsAreEqual(prev, next) {
    var prevSystem = prev.unstable_system,
        prevProps = _objectWithoutPropertiesLoose(prev, ["unstable_system"]);

    var nextSystem = next.unstable_system,
        nextProps = _objectWithoutPropertiesLoose(next, ["unstable_system"]);

    if (prevSystem !== nextSystem && !shallowEqual(prevSystem, nextSystem)) {
      return false;
    }

    return shallowEqual(prevProps, nextProps);
  }
});
var Box = createComponent({
  as: "div",
  useHook: useBox
});

var tags = function tags(props) {
  var _props$elementProps, _props$elementProps2, _props$elementProps3, _props$elementProps4, _props$elementProps5, _props$elementProps6, _props$elementProps7, _props$elementProps8, _props$elementProps9, _props$elementProps10, _props$elementProps11, _props$elementProps12, _props$elementProps13, _props$elementProps14, _props$elementProps15, _props$elementProps16, _props$elementProps17, _props$elementProps18, _props$elementProps19, _props$elementProps20, _props$elementProps21, _props$elementProps22, _props$elementProps23;

  return {
    p: {
      Component: Paragraph,
      props: props === null || props === void 0 ? void 0 : (_props$elementProps = props.elementProps) === null || _props$elementProps === void 0 ? void 0 : _props$elementProps.p
    },
    strong: {
      Component: Text,
      props: _objectSpread2$1({
        fontWeight: 'semibold'
      }, props === null || props === void 0 ? void 0 : (_props$elementProps2 = props.elementProps) === null || _props$elementProps2 === void 0 ? void 0 : _props$elementProps2.strong)
    },
    em: {
      Component: Text,
      props: _objectSpread2$1({
        use: 'em'
      }, props === null || props === void 0 ? void 0 : (_props$elementProps3 = props.elementProps) === null || _props$elementProps3 === void 0 ? void 0 : _props$elementProps3.em)
    },
    a: {
      Component: Link,
      props: props === null || props === void 0 ? void 0 : (_props$elementProps4 = props.elementProps) === null || _props$elementProps4 === void 0 ? void 0 : _props$elementProps4.a
    },
    blockquote: {
      Component: Blockquote,
      props: props === null || props === void 0 ? void 0 : (_props$elementProps5 = props.elementProps) === null || _props$elementProps5 === void 0 ? void 0 : _props$elementProps5.blockquote
    },
    h1: {
      Component: Heading,
      props: _objectSpread2$1({
        use: 'h1'
      }, props === null || props === void 0 ? void 0 : (_props$elementProps6 = props.elementProps) === null || _props$elementProps6 === void 0 ? void 0 : _props$elementProps6.h1)
    },
    h2: {
      Component: Heading,
      props: _objectSpread2$1({
        use: 'h2'
      }, props === null || props === void 0 ? void 0 : (_props$elementProps7 = props.elementProps) === null || _props$elementProps7 === void 0 ? void 0 : _props$elementProps7.h2)
    },
    h3: {
      Component: Heading,
      props: _objectSpread2$1({
        use: 'h3'
      }, props === null || props === void 0 ? void 0 : (_props$elementProps8 = props.elementProps) === null || _props$elementProps8 === void 0 ? void 0 : _props$elementProps8.h3)
    },
    h4: {
      Component: Heading,
      props: _objectSpread2$1({
        use: 'h4'
      }, props === null || props === void 0 ? void 0 : (_props$elementProps9 = props.elementProps) === null || _props$elementProps9 === void 0 ? void 0 : _props$elementProps9.h4)
    },
    h5: {
      Component: Heading,
      props: _objectSpread2$1({
        use: 'h5'
      }, props === null || props === void 0 ? void 0 : (_props$elementProps10 = props.elementProps) === null || _props$elementProps10 === void 0 ? void 0 : _props$elementProps10.h5)
    },
    h6: {
      Component: Heading,
      props: _objectSpread2$1({
        use: 'h6'
      }, props === null || props === void 0 ? void 0 : (_props$elementProps11 = props.elementProps) === null || _props$elementProps11 === void 0 ? void 0 : _props$elementProps11.h6)
    },
    hr: _objectSpread2$1({
      Component: Divider
    }, props === null || props === void 0 ? void 0 : (_props$elementProps12 = props.elementProps) === null || _props$elementProps12 === void 0 ? void 0 : _props$elementProps12.hr),
    ul: {
      Component: List,
      props: _objectSpread2$1({
        listStyleType: 'disc',
        listStylePosition: 'inside'
      }, props === null || props === void 0 ? void 0 : (_props$elementProps13 = props.elementProps) === null || _props$elementProps13 === void 0 ? void 0 : _props$elementProps13.ul)
    },
    ol: {
      Component: List,
      props: _objectSpread2$1({
        isOrdered: true,
        listStylePosition: 'inside'
      }, props === null || props === void 0 ? void 0 : (_props$elementProps14 = props.elementProps) === null || _props$elementProps14 === void 0 ? void 0 : _props$elementProps14.ol)
    },
    li: {
      Component: List.Item,
      props: props === null || props === void 0 ? void 0 : (_props$elementProps15 = props.elementProps) === null || _props$elementProps15 === void 0 ? void 0 : _props$elementProps15.li
    },
    table: {
      Component: Table,
      props: props === null || props === void 0 ? void 0 : (_props$elementProps16 = props.elementProps) === null || _props$elementProps16 === void 0 ? void 0 : _props$elementProps16.table
    },
    tbody: {
      Component: Table.Body,
      props: props === null || props === void 0 ? void 0 : (_props$elementProps17 = props.elementProps) === null || _props$elementProps17 === void 0 ? void 0 : _props$elementProps17.tbody
    },
    thead: {
      Component: Table.Head,
      props: props === null || props === void 0 ? void 0 : (_props$elementProps18 = props.elementProps) === null || _props$elementProps18 === void 0 ? void 0 : _props$elementProps18.thead
    },
    tfoot: {
      Component: Table.Foot,
      props: props === null || props === void 0 ? void 0 : (_props$elementProps19 = props.elementProps) === null || _props$elementProps19 === void 0 ? void 0 : _props$elementProps19.tfoot
    },
    tr: {
      Component: Table.Row,
      props: props === null || props === void 0 ? void 0 : (_props$elementProps20 = props.elementProps) === null || _props$elementProps20 === void 0 ? void 0 : _props$elementProps20.tr
    },
    td: {
      Component: Table.Cell,
      props: props === null || props === void 0 ? void 0 : (_props$elementProps21 = props.elementProps) === null || _props$elementProps21 === void 0 ? void 0 : _props$elementProps21.td
    },
    th: {
      Component: Table.HeadCell,
      props: props === null || props === void 0 ? void 0 : (_props$elementProps22 = props.elementProps) === null || _props$elementProps22 === void 0 ? void 0 : _props$elementProps22.th
    },
    img: {
      Component: Image,
      props: props === null || props === void 0 ? void 0 : (_props$elementProps23 = props.elementProps) === null || _props$elementProps23 === void 0 ? void 0 : _props$elementProps23.img
    }
  };
};

var useProps$1 = createHook$1(function (props, _ref) {
  var themeKey = _ref.themeKey;

  var content = props.content,
      wrap = props.wrap,
      restProps = _objectWithoutPropertiesLoose$2(props, ["content", "wrap"]);

  var boxProps = Box$1.useProps(restProps);
  var className = useClassName({
    style: Markdown$1,
    styleProps: props,
    themeKey: themeKey,
    prevClassName: boxProps.className
  });
  var handleIterate = useCallback(function (restProps) {
    return function (Tag, props, children) {
      var _ref2 = tags(_objectSpread2$1(_objectSpread2$1({}, props), restProps))[Tag] || {
        Component: Tag
      },
          Component = _ref2.Component,
          _ref2$props = _ref2.props,
          overrideProps = _ref2$props === void 0 ? {} : _ref2$props;

      return (
        /*#__PURE__*/
        // @ts-ignore
        createElement(Component, _extends({}, props, overrideProps || {}), children)
      );
    };
  }, []);
  return _objectSpread2$1(_objectSpread2$1({}, boxProps), {}, {
    className: className,
    children: wrap( /*#__PURE__*/createElement(MarkdownRenderer, {
      onIterate: handleIterate(restProps),
      text: content,
      tags: {
        html: Fragment
      }
    }))
  });
}, {
  defaultProps: {
    wrap: function wrap(children) {
      return children;
    }
  },
  themeKey: 'Markdown'
});
var Markdown = createComponent$1(function (props) {
  var markdownProps = useProps$1(props);
  return createElement$1({
    children: props.children,
    component: Box,
    use: props.use,
    htmlProps: markdownProps
  });
}, {
  attach: {
    useProps: useProps$1
  },
  themeKey: 'Markdown'
});

export { Markdown };
